import { useRef, useState } from "react";
import { Loader2, Upload as UploadIcon } from "lucide-react";
import { toast } from "sonner";
import { adminApi, asset } from "../../lib/api";

export const ImageField = ({ value, onChange, label = "Image", scope = "admin" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file || !file.type.startsWith("image/")) { toast.error("Choose an image file."); return; }
    setBusy(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await adminApi.post("/upload", form, { params: { scope }, headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch { toast.error("Upload failed."); }
    finally { setBusy(false); }
  };
  return (
    <div>
      <p className="font-mono text-[10px] uppercase tracking-widest text-[#8F877C] mb-2">{label}</p>
      <div className="flex items-center gap-3">
        {value ? (
          <img src={asset(value)} alt="" className="h-14 w-14 object-cover border border-[#2A201A]" />
        ) : (
          <div className="h-14 w-14 border border-dashed border-[#2A201A] flex items-center justify-center text-[#5c554c] text-[10px]">none</div>
        )}
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="paste image URL…"
          className="flex-1 bg-obsidian border border-[#2A201A] px-3 py-2 font-mono text-xs text-bone focus:outline-none focus:border-teal" />
        <input ref={ref} type="file" accept="image/*" hidden onChange={(e) => upload(e.target.files?.[0])} />
        <button type="button" onClick={() => ref.current?.click()} disabled={busy}
          className="inline-flex items-center gap-2 font-feature text-xs uppercase tracking-widest border border-[#2A201A] px-3 py-2 hover:border-teal hover:text-teal transition-colors disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <UploadIcon className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
};

export const Field = ({ label, value, onChange, placeholder }) => (
  <div>
    <p className="font-mono text-[10px] uppercase tracking-widest text-[#8F877C] mb-2">{label}</p>
    <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder}
      className="w-full bg-obsidian border border-[#2A201A] px-3 py-2.5 text-sm text-bone focus:outline-none focus:border-teal" />
  </div>
);
